import { Buffer } from "buffer";

export class BaseError<T extends string> extends Error {
    override name: T;
    override message: string;
    override cause: any;

    code: number;
    errorHash: string;

    constructor({
        name,
        message,
        code,
        cause,
        caller,
        params
    }: {
        name: T;
        message: string;
        code: number;
        cause?: any;
        caller?: string;
        params?: any;
    }) {
        super(message);
        this.name = name;
        this.message = message;
        this.cause = cause;
        this.code = code;

        this.errorHash = this.hash(caller, params);
    }

    /**
     * Generates a hash for the error
     * @param {string} action The action that caused the error
     * @param {any} params The parameters of the action
     * @returns {string} The hash of the error
     */
    hash(action: string | undefined, params: any): string {
        const details = {
            error: this.name,
            timestamp: Date.now(),
            message: this.message,
            caller: action,
            params: params,
            code: this.code
        };

        return Buffer.from(JSON.stringify(details)).toString('base64');
    }
}

export function isBaseError(error: any): error is BaseError<string> {
    return error instanceof BaseError;
}